import React from 'react';
import { Eye, Users } from 'lucide-react';

const About = () => {
    return (
        <section id="about" className="section-padding-lg pb-0 bg-primary-light relative overflow-hidden">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex flex-col lg:grid lg:grid-cols-2 lg:gap-16 items-end">
                    <div className="lg:order-2" data-aos="fade-left">
                        <p className="label-md mb-4 uppercase tracking-widest">Our Foundation</p>
                        <h2 className="heading-lg mb-6 sm:mb-8">
                            Founded by clinicians. Engineered for your peace of mind.
                        </h2>
                        <p className="paragraph-lg mb-8 sm:mb-10 text-base sm:text-lg">
                            We deliver big-company capabilities with concierge-style communication, acting as a proactive
                            partner to handle administrative complexity. You'll never be treated like a ticket number; you get a
                            direct line to the specialist handling your accounts.
                        </p>

                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 sm:gap-10 mb-0 lg:mb-12">
                            <div className="flex flex-col items-start" data-aos="fade-up" data-aos-delay="100">
                                <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center mb-4 text-accent">
                                    <Eye className="w-6 h-6" strokeWidth="1.5" />
                                </div>
                                <h3 className="font-bold text-secondary text-sm uppercase tracking-widest mb-1">Unmatched
                                    Visibility</h3>
                                <p className="paragraph-sm text-gray-500 text-sm">Real-time tracking of every claim from submission to payment.</p>
                            </div>
                            <div className="flex flex-col items-start" data-aos="fade-up" data-aos-delay="200">
                                <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center mb-4 text-accent">
                                    <Users className="w-6 h-6" strokeWidth="1.5" />
                                </div>
                                <h3 className="font-bold text-secondary text-sm uppercase tracking-widest mb-1">Shared
                                    Stewardship</h3>
                                <p className="paragraph-sm text-gray-500 text-sm">We care for your financial integrity as deeply as you care for patients.</p>
                            </div>
                        </div>
                    </div>

                    <div className="relative lg:mt-0 flex flex-col justify-end lg:order-1" data-aos="fade-right">
                        <div
                            className="relative rounded-t-[2.5rem] sm:rounded-t-[3rem] overflow-hidden max-w-[640px] mx-auto lg:max-w-none">
                            <img src="/assets/images/group.png" alt="Trustpoint Clinician Team"
                                className="w-full h-auto object-cover block" />
                        </div>
                    </div>
                </div>
            </div>

            <div className="w-full bg-motion-dark py-12 relative z-10" data-aos="fade-up">
                <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex flex-col md:flex-row items-center justify-between gap-8">
                        <div className="text-white text-center md:text-left">
                            <h3 className="text-2xl md:text-3xl font-serif font-bold mb-2">Ready to reclaim your time?</h3>
                            <p className="text-white/60 font-light">Join the clinics transforming their revenue cycle today.</p>
                        </div>
                        <div className="flex flex-col sm:flex-row gap-4">
                            <a href="#contact" className="btn-primary-lg px-10">
                                Get Started Now
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default About;
